import AXIOS from '@/utils/$axios';

// 验证 验证码
export const checkSms = data =>
    AXIOS.post('/hdc-admin/sys/user/checkSms', data);

// 验证 用户是否存在
export const checkUser = data =>
    AXIOS.post('/hdc-admin/sys/user/checkUser', data);

// 设置新密码
export const modifyPassword = data =>
    AXIOS.post('/hdc-admin/sys/user/modifyPassword', data);
